/* eslint-disable react/display-name */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react'
import { ApolloProvider } from '@apollo/client'
import createClient from './create-client'

export default function ({ element }, options) {
  return <ApolloProvider client={createClient(options.endpointUrl)}>{element}</ApolloProvider>
}
